import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddSurveyResultModel, APAEvaluationViewModel, CertificationBodyFeedbackSurveyViewModel, CourseEventViewModel } from 'src/app/_models/generatedModels';
import { CEUService, EventService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';
import { Model } from "survey-core";

@Component({
  selector: 'bxl-ceu-eval-modal',
  templateUrl: 'ceu-eval-modal.component.html',
})
export class CeuEvalModalComponent implements OnInit {
  initialized = false;
  @Input() courseEventId: number;
  @Input() feedbackSurveyId: number;
  @Input() eventTitle: string;
  @ViewChild('myForm') myForm: FormGroupDirective;
  errorMessage: string;
  submitComplete: Promise<{}> | undefined;
  survey: CertificationBodyFeedbackSurveyViewModel;
   surveyModel: Model;

  constructor(private ceuService: CEUService, public modal: NgbActiveModal, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.ceuService.getFeedbackSurvey(this.feedbackSurveyId).subscribe((result) => {
      this.survey = result;

      const survey = new Model(JSON.parse(result.feedbackSurveyJson));
      survey.onComplete.add(this.surveyComplete.bind(this));
      this.surveyModel = survey;
      this.initialized = true;
    });
  }

  surveyComplete(sender) {
    var model = new AddSurveyResultModel();
    model.dataJSON = JSON.stringify(sender.data);

    this.ceuService.submitFeedbackSurvey(this.feedbackSurveyId, this.courseEventId, model).subscribe((result) => {
      this.modal.close();

    }, error => {
      this.errorMessage = error.error[0];
    });
  }

  onSave() {

  }

}
